import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    getAccounts,
    getAccountsReport,
    getAccountDetails,
    createAccount,
    updateAccount,
    deleteAccount,
    getShipmentsReport
}

function getAccounts(query) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/accounts`)
           .set('access', Storage.getItem('access'))
           .query(query)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function getAccountsReport() {
    return new Promise((resolve, reject) => {

        Superagent
            .get(`${HOST_API}/accounts/report`)
            .set('access', Storage.getItem('access'))
            .responseType('blob')
            .end((err, res) => {
                if(err)
                    resolve(null)
                else
                    resolve(res.body)
            })
    })
}

function getAccountDetails(accountId) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/accounts/${accountId}/details`)
           .set('access', Storage.getItem('access'))
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function createAccount(data) {
    return new Promise((resolve, reject) => {

        const timezone = new Date().getTimezoneOffset()/60

        Superagent
           .post(`${HOST_API}/accounts`)
           .set('access', Storage.getItem('access'))
           .query({timezone})
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function updateAccount(accountId, data) {
    return new Promise((resolve, reject) => {

        const timezone = new Date().getTimezoneOffset()/60

        Superagent
           .put(`${HOST_API}/accounts/${accountId}`)
           .set('access', Storage.getItem('access'))
           .query({timezone})
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function deleteAccount(creditId) {
    return new Promise((resolve, reject) => {
        Superagent
           .delete(`${HOST_API}/accounts/${creditId}`)
           .set('access', Storage.getItem('access'))
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function getShipmentsReport(accountId) {
    return new Promise((resolve, reject) => {

        Superagent
            .get(`${HOST_API}/accounts/${accountId}/shipments/report`)
            .set('access', Storage.getItem('access'))
            .responseType('blob')
            .end((err, res) => {
                if(err)
                    resolve(null)
                else
                    resolve(res.body)
            })
    })
}